import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import Trackers from './pages/Trackers.js';
import UserForm from './Secondary Pages/addUser.js';
import EditPage from './pages/editPage.js'
import Login from './pages/login.js';
import ManagerDashboard from './pages/managerDashboard.js';
import AdminDashboard from './pages/AdminDashboard.js';
import { UserProvider } from './context/userContext.js';
import Users from './pages/usersPage.js';
import EditUser from './pages/editUser.js';
import AssignmentPage from './pages/AssignmentPage/trackerAssignment.jsx';
import InternalTrackers from './pages/internalTracker.js';
import { ToastContainer, toast } from 'react-toastify';
import AgeingReportPage from './pages/Reports/ageingReportFilters.js';
import ComplianceAgingReport from './pages/Reports/ageingReport.js';
import DetailedReportPage from './pages/Reports/detailedReportFilter.js';
import DetailedComplianceReport from './pages/Reports/detailedReport.js';
import UserReportFilterPage from './pages/Reports/userReportFilter.js';
import ComplianceTrackerTable from './pages/Reports/userReport.js';
import ComplianceReportPage from './pages/Reports/riskProfile.js';
import LegalUpdateReportFilterPage from './pages/Reports/legalUpdateReportFilter.js';
import LegalUpdateReportPage from './pages/Reports/legalUpdateReport.js';
import { SessionProvider } from './context/sessionContext.js';
import { CSRFContext } from './context/CSRFcontext.js';
import { useContext, useEffect } from 'react';
import { setGlobalCsrfToken } from './api.js';
import NotificationsPage from './pages/NotificationPage.js';
import Drive from './pages/Drive.js';
import ProfilePage from './pages/profilePage.js';
import ROLES from './common/roles.js'
import RoleRoute from './Components/RoleRoute.js';
import DashboardRedirect from './Components/DashboardRedirect.js';
import UnauthorizedPage from './pages/UnauthorizedPage.js';
import ForgotPassword from './pages/forgotPassword.js';
import LegalUpdatesPage from './pages/legalUpdates.js';
import LegalUpdateModal from './Components/LegalUpdateModalLink.js'
import NotFoundPage from './pages/NotFoundPage.jsx';
function App() {
  const { csrfToken } = useContext(CSRFContext);
  const location = useLocation();
  const background = location.state && location.state.background;
  const LAST_ROUTE_KEY = 'complisense:lastRoute';

  function RouteTracker() {
    const location = useLocation();

    useEffect(() => {
      const { pathname, search } = location;
      if (
        pathname === '/login' ||
        pathname === '/' ||
        pathname.startsWith('/forgot-password') ||
        pathname === '/unauthorized'
      ) {
        return;
      }
      localStorage.setItem(LAST_ROUTE_KEY, pathname + search);
    }, [location]);

    return null;
  }

  useEffect(() => {
    if (csrfToken) {
      setGlobalCsrfToken(csrfToken);
    }
  }, [csrfToken]);
  return (
    <>
      <ToastContainer position="top-center" autoClose={5000} />


      <Routes location={background || location}>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />

        <Route
          path="/forgot password"
          element={<Navigate to="/forgot-password" replace />}
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />


        <Route
          element={
            <SessionProvider>
              <UserProvider>
                <>
                  <RouteTracker />
                  <Outlet />
                </>
              </UserProvider>
            </SessionProvider>
          }
        >
          {/* public pages inside the protected shell */}
          <Route path="/dashboard" element={<DashboardRedirect />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/drive" element={<Drive />} />

          {/* list page (and full‑page fallback) */}
          <Route path="/legal-update" element={<LegalUpdatesPage />} />
          <Route path="/legal-update/:id" element={<LegalUpdatesPage />} />

          {/* role‑based sections */}
          <Route element={<RoleRoute allowed={[ROLES.OWNER]} />}>
            <Route path="/dashboard/owner" element={<ManagerDashboard />} />
            <Route path="/manage/internal-trackers" element={<InternalTrackers />} />
          </Route>

          <Route element={<RoleRoute allowed={[ROLES.OWNER, ROLES.MANAGER, ROLES.SENIOR_MANAGER]} />}>
            <Route path="/alltrackers" element={<Trackers />} />
          </Route>

          <Route element={<RoleRoute allowed={[ROLES.MANAGER, ROLES.SENIOR_MANAGER]} />}>
            <Route path="/dashboard/manager" element={<ManagerDashboard />} />
            <Route path="/reports/ageing_report" element={<AgeingReportPage />} />
            <Route path="/compliance-aging-report" element={<ComplianceAgingReport />} />
            <Route path="/reports/detailed-report" element={<DetailedReportPage />} />
            <Route path="/reports/detailed-report-results" element={<DetailedComplianceReport />} />
            <Route path="/reports/user-report" element={<UserReportFilterPage />} />
            <Route path="/reports/user-report-results" element={<ComplianceTrackerTable />} />
            <Route path="/reports/risk-profile" element={<ComplianceReportPage />} />
            <Route path="/reports/legal-update" element={<LegalUpdateReportFilterPage />} />
            <Route path="/reports/legal-update-results" element={<LegalUpdateReportPage />} />
            <Route path="/manage_tracker/assignment" element={<AssignmentPage />} />
          </Route>

          <Route element={<RoleRoute allowed={[ROLES.ADMIN]} />}>
            <Route path="/dashboard/admin" element={<AdminDashboard />} />
            <Route path="/add_user" element={<UserForm />} />
            <Route path="/manage/users" element={<Users />} />
            <Route path="/edit-user/:id" element={<EditUser />} />
          </Route>

          {/* misc */}
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/Edit/:uin" element={<EditPage />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>


      {background && (
        <SessionProvider>
          <UserProvider>
            <Routes>
              <Route path="/legal-update/:id" element={<LegalUpdateModal />} />
            </Routes>
          </UserProvider>
        </SessionProvider>
      )}
    </>
  );
}

export default App;
/*

  <Route path="/dashboard/owner" element={<OwnerRoute />}>
        <Route path="" element={<ComplianceCalendar />} />
      </Route>

      <Route path="/dashboard/manager" element={<ManagerRoute />}>
        
      </Route>
     

*/